<template>
  <div>
    <sweet-modal blocking title="GENERAL LEDGER (Transactions)" ref="glaTransactions" class="modal" v-on:close="closeModal">

      <el-row :gutter="20">
        <el-col :span="18" :offset="0">
          <h4 v-html="`${code} ${name} (${currencycode})`" style="margin-top: 0px;"></h4>
          <el-date-picker
            ref="datepicker"
            popper-class="custom-date-picker"
            size="mini"
            v-model="filter.dates"
            style="border-bottom: none"
            prefix-icon="el-icon-date"
            type="daterange"
            align="center"
            format="d MMM yy"
            :clearable="false"
            value-format="timestamp"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="setFilter"
            :picker-options="pickerOptions">
            </el-date-picker>

            <!-- <el-input v-model="filter.text" label="Search"></el-input> -->
        </el-col>
        <el-col :span="6" :offset="0" style="text-align: right;"><h4 v-html="`(${DRCRCode})`" style="margin-top: 0px;"></h4></el-col>
      </el-row>

      <div style="position: absolute; top: 40px; right: 40px;">
        <el-dropdown size="mini">
          <span class="el-dropdown-link">
            Report Action<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 26)">PDF</el-dropdown-item>
            <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 26)">XL
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,26)">Email</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <el-table
        :data="tableData"
        max-height="650"
        stripe
        style="width: 935px"
        :empty-text="$t('general_noData')">
        <el-table-column
          prop="date"
          label="Date">
          <template slot-scope="scope">
            <div>
              {{scope.row.date ? moment(scope.row.date).format('D MMM YY') : null }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="num"
          align="center"
          label="ID #">
          <template slot-scope="scope">
            <span style="color: #409EFF; cursor: pointer;" @click="openJournalEntries(scope.row)">{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          align="center"
          label="Cheque/Ref #">
          <template slot-scope="scope">
            <span>{{scope.row.chequeno}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="Description">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.transactionDescription"
              placement="top"
              title="Description"
              width="400"
              trigger="click"
              :content="scope.row.transactionDescription">
              <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="debit"
          align="center"
          label="Debit">
          <template slot-scope="scope">
            <div style="text-align: right;">
              {{Number(scope.row.debit) > 0 ? formatPrice(scope.row.debit) : null}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="credit"
          align="center"
          label="Credit">
          <template slot-scope="scope">
            <div style="text-align: right;">
              {{Number(scope.row.credit) > 0 ? formatPrice(scope.row.credit) : null}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="accountId"
          prop="endbalance"
          align="center"
          label="Balance">
          <template slot-scope="scope">
            <div style="text-align: right;">
              {{formatPrice(scope.row.endbalance)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="reconciled"
          align="center"
          label="Reconciled">
        </el-table-column>
      </el-table>
    </sweet-modal>

    <edit-journal-entry-modal
      :showInfo="false"
      ref="editJournalEntryModal"/>
  </div>
</template>

<script>
import downloadexcel from "vue-json-excel";
import jsPDF from "jspdf";
import axios from 'axios'
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";
import moment from "moment";
import EditJournalEntryModal from "../../journalAndGl/editJournalEntryModal";
export default {
  name: "BankAccountTransactionModal",
  components: {
    EditJournalEntryModal,
    SweetModal,
    downloadexcel
  },
  data() {
    return {
      moment: moment,

      filter: {
        dates: [],
        text: ''
      },

      tableData: [],
      accountId: null,
      code: null,
      name: null,
      currencycode: null,
      DRCRCode: null,

      pickerOptions: {
        shortcuts: [
          {
            text: "This month",
            onClick(picker) {
              const end = moment().endOf("month");
              const start = moment().startOf("month");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment().endOf("month").subtract(1, "months");
              const start = moment().startOf("month").subtract(1, "months");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment().endOf("month").subtract(1, "months");
              const start = moment().startOf("month").subtract(3, "months");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "This financial quarter",
            onClick(picker) {
              const end = moment().endOf("quarter");
              const start = moment().startOf("quarter");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last financial quarter",
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "This financial year",
            onClick(picker) {
              const end = moment().endOf("year");
              const start = moment().startOf("year");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last financial year",
            onClick(picker) {
              const end = moment().endOf("year").subtract(1, "year");
              const start = moment().startOf("year").subtract(1, "year");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout;
    },
    financialYearStartDateFormatted () {
      return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
    },
    financialYearStartDate() {
      return this.companyLayout ? this.companyLayout.financialYearStartDate : null
    }
  },
  methods: {
    async openModal(row, dates) {
      console.log('row', row)
      if (row) {
        this.accountId = row.id
        this.code = row.code
        this.name = row.name
        this.DRCRCode = row.DRCRCode
        this.currencycode = row.currencycode
      }

      this.filter.dates = [
        this.financialYearStartDate
            ? moment(this.financialYearStartDate, "DD-MM-yyyy")
            : "2022-01-01",
        moment(),
      ];

      await this.loadList()

      this.$refs.glaTransactions.open()
    },
    setFilter(val) {
      if (!val) {
        this.filter.dates = [];
      } else {
        const start = moment(this.filter.dates[0]).format("YYYY-MM-DD");
        const end = moment(this.filter.dates[1]).format("YYYY-MM-DD");
        this.loadList(start, end);
      }
    },
    async loadList() {
      try {
        let loader = this.$loading.show();

        let url = `/api/v1/bankAccount/allTransaction?companyId=${this.$route.query.companyId}&startDate=${moment(this.filter.dates[0]).format("YYYY-MM-DD")}&endDate=${moment(this.filter.dates[1]).format("YYYY-MM-DD")}`
        if (this.accountId) {
          url = `/api/v1/bankAccount/transaction?companyId=${this.$route.query.companyId}&startDate=${moment(this.filter.dates[0]).format("YYYY-MM-DD")}&endDate=${moment(this.filter.dates[1]).format("YYYY-MM-DD")}&accountId=${this.accountId}`
        }
        const { data } = await axios.get(url)
        loader.hide()
        const totalObject = {
          debit: data.list.reduce((accumulator, currentVal) => {
            return accumulator + Number(currentVal.debit)
          }, 0),
          credit: data.list.reduce((accumulator, currentVal) => {
            return accumulator + Number(currentVal.credit)
          }, 0),
          endbalance: 0
        }
        totalObject.endbalance = totalObject.debit - totalObject.credit
        data.list.push(totalObject)
        console.log('data.list', data.list)
        this.tableData =  data.list
      } catch (err) {
        console.log(err)
      }
    },
    closeModal() {
      this.accountId = null
      this.tableData = [],
          this.filter.dates = [
            this.financialYearStartDate
                ? moment(this.financialYearStartDate, "DD-MM-yyyy")
                : "2022-01-01",
            moment(),
          ];
      this.code = null
      this.name = null
      this.DRCRCode = null
    },
    openJournalEntries(data) {
      const row = {
        id: data.transactionId,
        status: 'Add'
      }
      this.$refs.editJournalEntryModal.openModalFromJournalEntry(row)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    async exportData (typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          startDate: this.filter.dates && this.filter.dates[0] ? moment(this.filter.dates[0], 'x').format('YYYY-MM-DD') : 'null',
          endDate: this.filter.dates && this.filter.dates[1] ? moment(this.filter.dates[1], 'x').format('YYYY-MM-DD') : 'null',
          email: email,
          optionalField: {
            name: 'accountId',
            value: this.accountId.toString()
          }
        }
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        const { data } = await axios.post(`/api/v1/export`, payload)
        switch (typeExportId) {
          case 2: // pdf
          case 1: // xl
            window.open(data.file.downloadPath).focus()
            break
        }
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-range-separator {
  width: 30px !important;
}
</style>

<style lang="less">
.sweet-modal-overlay{
  .sweet-modal {
    max-width: 1000px !important;
  }
}

.sweet-modal-overlay{
  z-index:1000;
}
</style>
